import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';

import { StatusChip } from '@/components/Cards/Chips/StatusChip';
import { formatDate, formatDeliveryTypeCode } from '@/utils/common';
import { pickupStatusColor } from '@/utils/orders';

export const pickupColumns = (
  handleOpenDownloadModal: (trackingId?: string) => void,
): Array<GridColDef> => [
  {
    field: 'trackingId',
    flex: 1,
    headerName: `Nº de seguimiento`,
    width: 200,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography variant="body2" display={'inline'} sx={{ fontWeight: 'bold' }}>
        {params.row.trackingId}
      </Typography>
    ),
  },
  {
    field: 'createdAt',
    flex: 1,
    headerName: 'Fecha de recolección',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ display: 'inline', color: (theme) => theme.palette.grey[600] }}
      >
        {params.row.additional.pickupAfter
          ? formatDate(params.row.additional.pickupAfter)
          : formatDate(params.row.createdAt)}
      </Typography>
    ),
  },
  {
    field: 'destination',
    flex: 2,
    headerName: 'Destino',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ textAlign: 'left', color: (theme) => theme.palette.grey[600], display: 'inline' }}
      >
        {params.row.destination.address}
      </Typography>
    ),
  },
  {
    field: 'deliveryType',
    flex: 0.5,
    headerName: 'Modalidad',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        display={'inline'}
        sx={{ fontWeight: 'bold', color: (theme) => theme.palette.grey[600] }}
      >
        {formatDeliveryTypeCode(params.row.deliveryType)}
      </Typography>
    ),
  },
  {
    field: 'status',
    flex: 1,
    headerName: 'Estatus',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box>
        <StatusChip
          status={params.row.statusNameES}
          color={pickupStatusColor(params.row.statusNameES).bg}
          bg={pickupStatusColor(params.row.statusNameES).color}
        />
      </Box>
    ),
  },
  {
    field: 'actions',
    flex: 0.5,
    headerName: 'Acciones',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    resizable: false,
    renderCell: (params) => {
      return (
        <Box>
          {params.row.statusNameEN !== 'Draft' && (
            <Tooltip followCursor title="Descarga de etiquetas" placement="top">
              <IconButton
                color="primary"
                onClick={() => handleOpenDownloadModal(params.row.trackingId)}
              >
                <CloudDownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    },
  },
];
